require('../../newAccountSteps/profileSteps/profileSteps.scss');
//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const { Form } = require('react-redux-form');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const validator = require('validator');
// @ commons
import { formatText, getLanguage } from 'core/i18n';
//@actions
const formActions = require('react-redux-form').actions;
const stepsActions = require('actions/stepsActions');
const optionsActions = require('actions/optionsActions');

//@utilities
const tools = require('utilities/tools');

//@components
const { SignaturePattern } = require('components/changeDataAC/signaturePattern/signaturePattern');
const GeoAddress = require('components/GeoAddress');
const GeoSelect = require('components/GeoAddress/GeoFields/GeoSelect');
const GeoInput = require('components/GeoAddress/GeoFields/GeoInput');
const GeoRowGroup = require('components/GeoAddress/GeoRowGroup');

// NO SE ESTA USANDO, SE ESTA USANDO ProfileStep1Form.js en newAccountSteps
export class ItemAddressContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            closeComponent: false,
            showComponentSignaturePattern: false,
            disabled: false,
            newAddress: [],
        };

        this.buildAddOrSaveButton = this.buildAddOrSaveButton.bind(this);
        this.buildCancelButton = this.buildCancelButton.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.isFilledAddress = this.isFilledAddress.bind(this);
        this.handleCheckValidPostalCode = this.handleCheckValidPostalCode.bind(this);
        this.handleCompleteFields = this.handleCompleteFields.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.formActions.change('userProfile.address_2', '');
        this.props.formActions.change('userProfile.typeOfRoad_2', '');
        this.props.formActions.change('userProfile.addressNumber_2', '');
        this.props.formActions.change('userProfile.nameOfRoad_2', '');
        this.props.formActions.change('userProfile.postalCode_2', '');
        this.props.formActions.change('userProfile.province_2', '');
        this.props.formActions.change('userProfile.town_2', '');
        this.props.formActions.change('userProfile.address_2Filled', true);
    }

    handleCheckValidPostalCode(field) {
        const { userProfile, formActions } = this.props;
        if (
            (field === 'province_2' || field === 'postalCode_2') &&
            !tools.isEmptyOrWhitespace(userProfile.postalCode_2) &&
            !tools.isEmptyOrWhitespace(userProfile.province_2)
        ) {
            formActions.setValidity('userProfile.postalCode_2', {
                zip: userProfile.postalCode_2.startsWith(userProfile.province_2),
            });
        }
    }

    handleValidateValidFields() {
        const { formActions, userProfileForm } = this.props;

        const requiredFields = [
            'address_2',
            'typeOfRoad_2',
            'addressNumber_2',
            'nameOfRoad_2',
            'postalCode_2',
            'province_2',
        ];
        const requiredFlag = requiredFields.some(field => !userProfileForm[field].valid);

        if (requiredFlag) {
            requiredFields.forEach(field => {
                if (!userProfileForm[field].valid) {
                    formActions.setValidity(`userProfile.${field}`, { required: false });
                }
            });
        }

        return !requiredFlag;
    }

    handleCompleteFields() {
        const { formActions, userProfileForm } = this.props;

        const requiredFields = [
            'address_2',
            'typeOfRoad_2',
            'addressNumber_2',
            'nameOfRoad_2',
            'postalCode_2',
            'province_2',
        ];
        const requiredFlag = requiredFields.some(field => userProfileForm[field].value === '');

        if (requiredFlag) {
            requiredFields.forEach(field => {
                if (userProfileForm[field].value === '') {
                    formActions.setValidity(`userProfile.${field}`, { required: false });
                }
            });
        }

        return !requiredFlag;
    }

    buildAddOrSaveButton() {
        let buttonText = 'Modificar';
        return (
            <button type="submit" className="form__button form__button-primaryB">
                {buttonText}
            </button>
        );
    }

    handleSubmit() {
        const { userProfile } = this.props;
        const isValid = this.handleValidateValidFields();
        const isComplete = this.handleCompleteFields();
        let newAddress = this.state.newAddress;
        if (isValid && isComplete) {
            const json = {
                postalCode: userProfile.postalCode_2,
                town: userProfile.town_2,
                nameOfRoad: userProfile.nameOfRoad_2,
                addressNumber: userProfile.addressNumber_2,
                province: userProfile.province_2,
                additionalInfo: userProfile.additionalInfo_2,
                typeOfRoad: userProfile.typeOfRoad_2,
                country: userProfile.country,
            };
            newAddress.push(json);
            this.setState({
                newAddress: newAddress,
            });
            this.setState({
                showComponentSignaturePattern: true,
            });
        }
    }

    buildCancelButton() {
        return (
            <button type="button" className="form__button form__button-negativeB" onClick={this.handleCancel}>
                {formatText('button-cancel')}
            </button>
        );
    }

    handleCancel() {
        const { formActions } = this.props;
        formActions.change('userProfile.address_2Filled', false);
        formActions.resetValidity('userProfile.address_2');
        formActions.resetValidity('userProfile.typeOfRoad_2');
        formActions.resetValidity('userProfile.addressNumber_2');
        formActions.resetValidity('userProfile.nameOfRoad_2');
        formActions.resetValidity('userProfile.postalCode_2');
        formActions.resetValidity('userProfile.province_2');
        formActions.resetValidity('userProfile.town_2');
        formActions.resetValidity('userProfile.additionalInfo_2');
        formActions.change('userProfile.address_2', '');
        formActions.change('userProfile.typeOfRoad_2', '');
        formActions.change('userProfile.addressNumber_2', '');
        formActions.change('userProfile.nameOfRoad_2', '');
        formActions.change('userProfile.postalCode_2', '');
        formActions.change('userProfile.province_2', '');
        formActions.change('userProfile.town_2', '');
        formActions.change('userProfile.additionalInfo_2');
        this.props.onCancel();
    }

    handleSuccess() {
        this.props.onSuccess();
    }

    isFilledAddress() {
        const { userProfile } = this.props;
        const filled = userProfile.address_2Filled ? true : false;
        return filled;
    }

    render() {
        const cancelButton = this.buildCancelButton();
        const saveButton = this.buildAddOrSaveButton();
        let data = { address: this.state.newAddress };
        const modifyAddress = (
            <div className="changeData">
                <div className="inner-form">
                    <Form id="formChangeData" model="userProfile" onSubmit={this.handleSubmit}>
                        <div className="title-box__title--blue">
                            <label>{formatText('changeData-modifyAddress')}</label>
                        </div>
                        <div className="change-data__subtitle__margin">
                            <span>{formatText('changeData-tipAddress')}</span>
                        </div>
                        <div className="profile-step-1 md-form-group">
                            <GeoAddress
                                baseModelDescriptor="userProfile"
                                baseModelProperty="address_2"
                                baseModelForm={this.props.userProfileForm}
                                value={this.props.userProfile.address_2}
                                id="addressAutocomplete"
                                isFilled={this.isFilledAddress}
                                language={getLanguage()}
                            >
                                <GeoRowGroup>
                                    <GeoSelect
                                        id="typeOfRoad"
                                        baseModelProperty="typeOfRoad_2"
                                        gmapsType="type_of_road"
                                        options={this.props.options.get('typesOfRoads').toJS()}
                                        value={this.props.userProfile.typeOfRoad_2}
                                        label={formatText('field-typeOfRoad')}
                                        size={4}
                                        validators={{
                                            required: value => !tools.isEmptyOrWhitespace(value),
                                        }}
                                        errorMessages={{
                                            required: formatText('changeData-required'),
                                        }}
                                    />
                                    <GeoInput
                                        id="nameOfRoad"
                                        baseModelProperty="nameOfRoad_2"
                                        gmapsType="route"
                                        value={this.props.userProfile.nameOfRoad_2}
                                        label={formatText('field-nameOfRoad')}
                                        size={8}
                                        maxLength={45}
                                        placeholder={formatText('field-nameOfRoad')}
                                        validators={{
                                            required: value => !tools.isEmptyOrWhitespace(value),
                                            valid: value => {
                                                //FIXME: ^[A-Z0-9À-ÿ_./\\?,:;-\s\u005B\u005D\u003C\u003E\u00B0\u00AA\u00BA]*$
                                                return (
                                                    !tools.isEmptyOrWhitespace(value) &&
                                                    validator.matches(
                                                        value.toString(),
                                                        /^[A-Z0-9À-ÿ_./\\?,:;'-\s\u005B\u005D\u003C\u003E\u00B0\u00AA\u00BA]+$/i
                                                    ) &&
                                                    value.length <= 45
                                                );
                                            },
                                        }}
                                        errorMessages={{
                                            required: formatText('changeData-required'),
                                            valid: formatText('validation-syntaxError'),
                                        }}
                                    />
                                </GeoRowGroup>
                                <GeoRowGroup>
                                    <GeoInput
                                        id="addressNumber"
                                        baseModelProperty="addressNumber_2"
                                        gmapsType="street_number"
                                        value={this.props.userProfile.addressNumber_2}
                                        label={formatText('field-number')}
                                        size={4}
                                        placeholder={formatText('field-number')}
                                        validators={{
                                            required: value => !tools.isEmptyOrWhitespace(value),
                                            valid: value => {
                                                let result = true;
                                                if (!tools.isEmptyOrWhitespace(value)) {
                                                    if (
                                                        validator.isAlphanumeric(value) &&
                                                        !validator.isNumeric(value)
                                                    ) {
                                                        result = false;
                                                    } else {
                                                        result = validator.matches(
                                                            value.toString(),
                                                            /^S\/N$|^s\/n$|^[0-9]*$/
                                                        );
                                                    }
                                                }
                                                return result;
                                            },
                                            length: value => {
                                                let result = true;
                                                if (validator.isNumeric(value)) {
                                                    result = value.length <= 3;
                                                }
                                                return result;
                                            },
                                        }}
                                        errorMessages={{
                                            required: formatText('validation-numberRequired'),
                                            valid: formatText('validation-numberNoValid'),
                                            length: formatText('validation-numberLength'),
                                        }}
                                    />
                                    <GeoInput
                                        id="additionalInfo"
                                        baseModelProperty="additionalInfo_2"
                                        gmapsType="additional_info"
                                        value={this.props.userProfile.additionalInfo_2}
                                        label={formatText('field-additionalInfoLabel')}
                                        size={8}
                                        maxLength={50}
                                        placeholder={formatText('field-additionalInfo')}
                                        validators={{
                                            valid: value => {
                                                //FIXME: ^[A-Z0-9À-ÿ_./\\?,:;-\s\u005B\u005D\u003C\u003E\u00B0\u00AA\u00BA]*$
                                                return (
                                                    tools.isEmptyOrWhitespace(value) ||
                                                    (validator.matches(
                                                        value.toString(),
                                                        /^[A-Z0-9À-ÿ_./\\?,:;-\s\u005B\u005D\u003C\u003E\u00B0\u00AA\u00BA]*$/i
                                                    ) &&
                                                        value.length <= 40) ||
                                                    true
                                                );
                                            },
                                        }}
                                        errorMessages={{
                                            valid: formatText('validation-syntaxError'),
                                        }}
                                    />
                                </GeoRowGroup>
                                <GeoRowGroup>
                                    <GeoInput
                                        id="postalCode"
                                        baseModelProperty="postalCode_2"
                                        gmapsType="postal_code"
                                        value={this.props.userProfile.postalCode_2}
                                        label={formatText('field-postalCode')}
                                        size={4}
                                        maxLength={5}
                                        placeholder={formatText('field-postalCode')}
                                        validators={{
                                            required: value => !tools.isEmptyOrWhitespace(value),
                                            valid: value => {
                                                return (
                                                    !tools.isEmptyOrWhitespace(value) &&
                                                    validator.isInt(value.toString(), {
                                                        min: 0,
                                                        allow_leading_zeroes: true,
                                                    })
                                                );
                                            },
                                        }}
                                        errorMessages={{
                                            required: formatText('validation-fieldRequired'),
                                            valid: formatText('validation-syntaxError'),
                                            zip: formatText('validation-postalCodeServer'),
                                        }}
                                        onUpdate={this.handleCheckValidPostalCode}
                                    />
                                    <GeoInput
                                        id="town"
                                        baseModelProperty="town_2"
                                        gmapsType="town"
                                        value={this.props.userProfile.town_2}
                                        label={formatText('field-town')}
                                        size={4}
                                        maxLength={40}
                                        placeholder={formatText('field-town')}
                                        validators={{
                                            valid: value => {
                                                return (
                                                    tools.isEmptyOrWhitespace(value) ||
                                                    (validator.matches(
                                                        value.toString(),
                                                        /^[a-zA-ZÀ-ÿ'\s\u005B\u005D]+$/
                                                    ) &&
                                                        value.length <= 40)
                                                );
                                            },
                                        }}
                                        errorMessages={{
                                            valid: formatText('validation-syntaxError'),
                                        }}
                                    />
                                    <GeoSelect
                                        id="province"
                                        baseModelProperty="province_2"
                                        gmapsType="administrative_area_level_2"
                                        options={this.props.options.get('cities').toJS()}
                                        value={this.props.userProfile.province_2}
                                        label={formatText('field-province')}
                                        size={4}
                                        validators={{
                                            required: value => !tools.isEmptyOrWhitespace(value),
                                        }}
                                        errorMessages={{
                                            required: formatText('changeData-required'),
                                            zip: formatText('validation-postalCodeServer'),
                                        }}
                                        onUpdate={this.handleCheckValidPostalCode}
                                    />
                                </GeoRowGroup>
                                <GeoInput
                                    id="country"
                                    baseModelProperty="country_2"
                                    gmapsType="country"
                                    value={this.props.userProfile.country_2}
                                    size={0}
                                />
                            </GeoAddress>
                        </div>
                        <hr className="no-mrg-top" />
                        <div className="inner-form__footer">
                            <div className="inner-form__footer--buttons">
                                {cancelButton}
                                {saveButton}
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
        return (
            <div>
                {this.state.showComponentSignaturePattern ? (
                    <SignaturePattern
                        onSuccess={this.handleSuccess}
                        onCancel={this.handleCancel}
                        data={data}
                        operationType={'modify_address'}
                    />
                ) : (
                    modifyAddress
                )}
            </div>
        );
    }
}

ItemAddressContent.propTypes = {
    handleSave: PropTypes.func,
    handleNextStep: PropTypes.func,
    handleShowPassport: PropTypes.func,
    passport: PropTypes.any,
    showJointHolderDecision: PropTypes.any,
    getCountries: PropTypes.any,
    showPassport: PropTypes.any,
    handleAddressUpdate: PropTypes.func,
    showOpenCredit: PropTypes.any,
    getProvinces: PropTypes.any,
};

module.exports.ItemAddressContent = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        options: state.options,
        focus: state.focus,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
    })
)(ItemAddressContent);
